import React, { FC } from "react";
import {
  Container,
  Footer as HedwigFooter,
  Link,
} from "@postenbring/hedwig-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRight } from "@fortawesome/pro-solid-svg-icons/faArrowUpRight";
import Translated from "../infrastructure/translation/Translated";
import { useLanguage } from "@digipost/translate";
import {
  getEnvBaseUrl,
  getTermsUrl,
} from "../infrastructure/translation/translatedUrls";
import styles from "./Footer.module.css";

const Footer: FC = (): React.ReactElement => {
  const { language } = useLanguage();

  return (
    <HedwigFooter variant="slim">
      <Container>
        <div className="hds-footer__logo-row">
          <HedwigFooter.Logo />
          <div className={styles.links}>
            <span>
              <Translated textKey={"footer.posten"} />
            </span>
            <Link href={getTermsUrl(language)} icon="leading">
              <FontAwesomeIcon icon={faArrowUpRight} aria-hidden />
              <Translated textKey={"footer.privacy"} />
            </Link>
            <Link href={getEnvBaseUrl() + "/cookies"} icon="leading">
              <FontAwesomeIcon icon={faArrowUpRight} aria-hidden />
              <Translated textKey={"footer.cookies"} />
            </Link>
          </div>
        </div>
      </Container>
    </HedwigFooter>
  );
};

export default Footer;
